<template>
  <div :style="containerStyle" class="relative w-full">
    <div class="absolute inset-0 w-full h-full">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Usage Example:
 * 
 * ```html
 * <AspectRatio aspectRatio="4:3">
 *  <img src="image.jpg" alt="Example Image" class="w-full h-full object-cover" />
 * </AspectRatio>
 * ```
 *
 * Replace `yourFunction`, `yourFile`, and arguments with actual names and values.
 */
export default {
  name: "AspectRatio",
  props: {
    aspectRatio: {
      type: String,
      default: "16:9",
    },
  },
  computed: {
    containerStyle() {
      const [w, h] = this.aspectRatio.split(":").map(Number);
      const paddingTop = h && w ? (h / w) * 100 : 56.25;
      return {
        paddingTop: `${paddingTop}%`,
      };
    },
  },
};
</script>
